import { globalApiHandler } from "../../services/services";
import { isAuthorized } from "../../components/Common/CheckAuthorization";

export const HARVEST_YEAR = {
  getHarvestYear: {
    success: "GET_HARVEST_YEAR"
  },
  selectedYear: {
    success: "SELECTED_HARVEST_YEAR"
  },
  createHarvestYear: {
    success: "CREATE_HARVEST_YEAR"
  }
};

export const getHarvestYear = farmId => {
  let url = `/ntrac/harvestYear/farmId/${farmId}`;
  return dispatch => {
    return globalApiHandler(url, "get")
      .then(response => {
        const data = response.data.data;
        isAuthorized() &&
          data.push({
            harvestYear: "Harvest Year Management",
            id: "harvestYearLink"
          });
        dispatch({ type: HARVEST_YEAR.getHarvestYear.success, data });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
        return false;
      });
  };
};

export const updateHarvestYear = yearName => {
  return dispatch => {
    dispatch({ type: HARVEST_YEAR.selectedYear.success, data: yearName });
  };
};

export const createHarvestYear = harvestInfo => {
  let url = `/ntrac/harvestYear/`;
  return dispatch => {
    return globalApiHandler(url, "post", harvestInfo)
      .then(response => {
        const data = response.data.data;
        dispatch({ type: HARVEST_YEAR.createHarvestYear.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
        return false;
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/harvestYearManagement/action.js